// extracted by mini-css-extract-plugin
export default {"info":"Info_info__chYJP","toBottom":"Info_toBottom__IOJBP","p":"Info_p__16VRv","toRight":"Info_toRight__ZWyhu"};